import { helper } from '@ember/component/helper';

const map = {
  none: 'unitless',
};

export default helper(function parameterUnitHelper([ value ]) {
  const key = ((value || '') + '').toLowerCase();
  return key in map ? map[key] : value;
});
